import { compose, bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { Form } from "antd";

import {
  fetchTaxReceiptPlatformIssuingEnabled,
  fetchTaxReceiptCampaignIssuingEnabled,
  fetchTaxReceiptCampaignIssuingStatus,
  updateTaxReceiptCampaignIssuingStatus,
  fetchTaxReceiptCampaignIssuingStatusLogs,
} from '../../taxReceiptActions';

import {
  fetchEvent,
  updateEventSettings,
} from '../../../Event/eventActions.js';

import TaxReceiptCampaignSettingsPanel from './TaxReceiptCampaignSettingsPanel';

const mapStateToProps = state => ({
  campaignIssuingStatus: state.TaxReceipt.campaignIssuingStatus,
  isUpdateCampaignIssuingStatusInProgress: state.TaxReceipt.isUpdateCampaignIssuingStatusInProgress,
  plaformIssuingEnabled: state.TaxReceipt.plaformIssuingEnabled,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchTaxReceiptPlatformIssuingEnabled,
  fetchTaxReceiptCampaignIssuingEnabled,
  fetchTaxReceiptCampaignIssuingStatus,
  updateTaxReceiptCampaignIssuingStatus,
  fetchTaxReceiptCampaignIssuingStatusLogs,

  fetchEvent,
  updateEventSettings,
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  Form.create(),
)(TaxReceiptCampaignSettingsPanel);
